import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { instituteMock } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="navigation-header">
      <div className="header-content">
        <div className="logo-container" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img 
            src="/logo-retina-viva.png" 
            alt="Instituto Retina Viva" 
            className="header-logo"
          />
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <nav className={`navigation-menu ${isMenuOpen ? 'mobile-open' : ''}`}>
          <button className="navigation-link" onClick={() => scrollToSection('about-section')}>
            Sobre
          </button>
          <button className="navigation-link" onClick={() => scrollToSection('specializations-section')}>
            Especialização
          </button>
          <button className="navigation-link" onClick={() => scrollToSection('exams-section')}>
            Exames
          </button>
          <button className="navigation-link" onClick={() => scrollToSection('structure-section')}>
            Estrutura
          </button>
          <button className="navigation-link" onClick={() => scrollToSection('contact-section')}>
            Contato
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
